/**
 * Created by guga on 7/29/2016.
 */

/***********************************************
 * Author : Gustavo(gmm)
 * Date   : 29/07/2016
 *
 * This file contain the API_HOST
 * Change the value of API_HOST for development/deploy purpose
 *
 ***********************************************/

//Remote Host
//export const PRODUCTION_HOST : string = 'http://ec2-54-207-91-17.sa-east-1.compute.amazonaws.com/api';

//Local Host
export const LOCAL_HOST      : string = 'http://localhost:8888/minhasaude-api';
//export const PRODUCTION_HOST      : string = 'http://www.minhasaudeapi.com.br:8080/minhasaude-api';
export const PRODUCTION_HOST      : string = 'https://www.minhasaudeapi.com.br:8443/minhasaude-api';

//export const PRODUCTION_HOST      : string = 'http://localhost:8888/minhasaude-api';




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas/api-host.ts